module.exports = __webpack_public_path__ + "static/media/blue-arrow.6066ef42.svg";